<template>
    <ul class="list__ul">
        <template v-if="engine === AUTO_ENGINE.ELECTRIC.ID">
            <!--reseau-->
            <template v-if="type === INSURANCE_AUTO.TYPE_RESEAU.ID">

                <li>
                    <b>Dans le système Flux électrique :</b>
                    <div>
                        Moteur électrique, convertisseur, chargeur, calculateur, onduleur, motoventilateur, batterie de
                        traction.
                    </div>
                </li>
                <li>
                    <b>Dans le dispositif de Transmission :</b>
                    <div>
                        Arbre de transmission, différentiels, cardans.
                    </div>
                </li>
                <li>
                    <b>Important :</b>
                    <div>
                        Cette garantie est réservée aux véhicules électriques de moins de 10 ans, avec une puissance, au
                        maximum de 400 Kw et n'excédant pas la limite kilométrique à la souscription de 150 000 km.
                    </div>
                </li>
            </template>
            <!--maxi reseau-->
            <template v-if="type === INSURANCE_AUTO.TYPE_MAXI_RESEAU.ID">

                <li>
                    <b>Dans le système Flux électrique:</b>
                    <div>
                        Moteur électrique, convertisseur, chargeur, calculateur, onduleur, motoventilateur, batterie de
                        traction.
                    </div>
                </li>
                <li>
                    <b>Dans le dispositif de Transmission :</b>
                    <div>
                        Arbre de transmission, différentiels, cardans.
                    </div>
                </li>
                <li>
                    <b>Dans le système de Refroidissement :</b>
                    <div>
                        Radiateur d’eau, pompe à eau, ventilateur.
                    </div>
                </li>
                <li>
                    <b>Dans le système de Freinage :</b>
                    <div>
                        Maître-cylindre, servofrein, bloc ABS.
                    </div>
                </li>
                <li>
                    <b>Dans le système de Direction :</b>
                    <div>
                        Crémaillère ou boîtier, pompe d’assistance. A l’exception de la colonne, des rotules et des
                        biellettes.
                    </div>
                </li>
                <li>
                    <b>Dans le système Électrique :</b>
                    <div>
                        Serrure de porte, moteurs et mécanismes de lèves vitres, moteurs d’essuie-glace et de toit
                        ouvrant, compresseur et condenseur de climatisation, à l’exception de la recharge de gaz.
                        Potentiomètre pédale accélérateur.
                    </div>
                </li>
                <li>
                    <b>Important :</b>
                    <div>
                        Cette garantie est réservée aux véhicules électriques de moins de 7 ans, avec une puissance, au
                        maximum de 400 Kw et n'excédant pas la limite kilométrique à la souscription de 100 000 km.
                    </div>
                </li>

            </template>
        </template>
        <template v-else>
            <!--standard-->
            <template v-if="type === INSURANCE_AUTO.TYPE_STANDARD.ID">
                <li>
                    <b>Moteur :</b>
                    <div>
                        L'arbre à cames, les coussinets de tête de bielle, les bielles, les culbuteurs et tiges de
                        culbuteurs,
                        les
                        poussoirs, chaînes de distribution, courroie de distribution (uniquement en cas de rupture),
                        paliers
                        de
                        vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile, culasse
                        et
                        joint
                        de
                        culasse.
                    </div>
                </li>
                <li>
                    <b>Boîte de vitesse :</b>

                    <div>
                        <i>Manuelle : </i>Toutes les défaillances internes : Pignon, arbres, sélecteurs, synchros,
                        roulements.
                    </div>
                    <div>
                        <i>Automatique : </i>Pignons, pompe à huile, bagues et arbres, convertisseur de couple, vannes
                        et
                        soupapes,
                        régulateur, plateau.
                    </div>
                </li>
                <li>
                    <b>Dispositif de transmission :</b>
                    <div>
                        Boite de transfert, pont arrière, différentiels, pignons et couronnes. A l\exception des arbres
                        de
                        roues, de
                        transmission et de cardans.
                    </div>
                </li>
                <li>
                    <b>Important :</b>
                    <div>
                        Cette garantie est réservée aux véhicules de moins de 15 ans, avec une cylindrée, au maximum de
                        3.5
                        litres
                        et n'excédant pas la limite kilométrique à la souscription de 250 000 km.
                    </div>
                </li>
            </template>

            <!--reseau-->
            <template v-if="type === INSURANCE_AUTO.TYPE_RESEAU.ID">
                <li>
                    <b>Moteur : </b> 
                    <div>
                        L'arbre à cames, les coussinets de tête de bielle, les bielles, les culbuteurs et tiges de
                        culbuteurs,
                        les
                        poussoirs, chaïnes de distribution, courroie de distribution (uniquement en cas de rupture),
                        paliers
                        de
                        vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile, culasse
                        et
                        joint
                        de
                        culasse, turbo.
                    </div>
                </li>
                <li>
                    <b>Bo&#xee;te de vitesse : </b>
                    <div>
                        Manuelle :Toutes les défaillances internes : Pignon, arbres, sélecteurs, synchros, roulements.
                    </div>
                    <div>
                        Automatique :Pignons, pompe à huile, bagues et arbres, convertisseur de couple, vannes et
                        soupapes,
                        régulateur, plateau.
                    </div>
                </li>
                <li>
                    <b>Dispositif de transmission : </b>
                    <div>
                        Bo&#xee;te de transfert, pont arrière, différentiels, pignons et couronnes, cardans, arbre de
                        transmission,
                        arbres de roues.
                    </div>
                </li>
                <li>
                    <b>
                        Composants complémentaires pour les véhicules hybrides :
                    </b>
                    <div>
                        Moteur électrique, convertisseur, chargeur, calculateur, onduleur, motoventilateur.
                    </div>
                </li>
                <li>
                    <b>Dans le système de refroidissement : </b>
                    <div>
                        Radiateur d'eau, pompe à eau, ventilateur.
                    </div>
                </li>
                <li>
                    <b>Dans le système de freinage : </b>
                    <div>
                        Ma&#xee;tre-cylindre, servofrein.
                    </div>
                </li>
                <li>
                    <b>Dans le système d'alimentation : </b>
                    <div>
                        Pompe à injection, pompes d'alimentation en carburant, boitier papillon d'injection, à
                        l'exception
                        des
                        injecteurs.
                    </div>
                </li>
                <li>
                    <b>Dans le dispositif d'embrayage : </b>
                    <div>
                        Mécanisme, fourchette.
                    </div>
                </li>
                <li>
                    <b>Important : </b>
                    <div v-if="age < 10">
                        Cette garantie est réservée aux véhicules de moins de 10 ans, avec une cylindrée, au maximum de
                        3.5
                        litres
                        et sans la limite kilométrique à la souscription.
                    </div>
                    <div v-else>
                        Cette garantie est réservée aux véhicules de moins de 15 ans, avec une cylindrée, au maximum de
                        4.5
                        litres
                        et n'excédant pas la limite kilométrique à la souscription de 150 000 km.
                    </div>
                </li>
            </template>

            <!--maxi reseau-->
            <template v-if="type === INSURANCE_AUTO.TYPE_MAXI_RESEAU.ID">
                <li>
                    <b>Moteur :</b>
                    <div>
                        L'arbre à cames, les coussinets de tête de bielle, les bielles, les culbuteurs et tiges de
                        culbuteurs,
                        les
                        poussoirs, chaînes de distribution, courroie de distribution (uniquement en cas de rupture), les
                        paliers
                        de
                        vilebrequin, le vilbrequin, les pistons et axes, les segments, les soupapes et guides, pompe à
                        huile, la
                        culasse, et joint de culasse, turbo.
                    </div>
                </li>
                <li>
                    <b>Boîte de vitesse :</b>
                    <div>
                        <i>Manuelle : </i>Toutes les défaillances internes : Pignon, arbres, sélecteurs, synchros,
                        roulements.
                    </div>
                    <div>
                        <i>Automatique : </i>Pignons, pompe à huile, bagues et arbres, convertisseur de couple, vannes
                        et
                        soupapes,
                        régulateur, plateau.
                    </div>
                </li>
                <li>
                    <b>Dispositif de transmission :</b>
                    <div>
                        Boite de transfert, pont arrière, différentiels, pignons et couronnes, cardans, arbre de
                        transmission,
                        arbres de roues.
                    </div>
                </li>
                <li>
                    <b>
                        Composants complémentaires pour les véhicules hybrides :
                    </b>
                    <div>
                        Moteur électrique, convertisseur, chargeur, calculateur, onduleur, motoventilateur.
                    </div>
                </li>
                <li>
                    <b>Système de refroidissement :</b>
                    <div>
                        Radiateur d'eau, pompe à eau, ventilateur.
                    </div>
                </li>
                <li>
                    <b>Système électrique :</b>
                    <div>
                        Alternateur, démarreur, serrures de portes, moteur et mécanisme de lève-vitres, moteur
                        d'essuie-glace et
                        de
                        toit ouvrant, compresseur et condenseur de climatisation, à l'exception de la recharge de gaz.
                    </div>
                </li>
                <li>
                    <b>Système de direction :</b>
                    <div>
                        Crémaillère ou boitier, pompe d'assistance. A l'exception de la colonne, des rotules et des
                        biellettes.
                    </div>
                </li>
                <li>
                    <b>Système de freinage :</b>
                    <div>
                        Maître-cylindre, servofrein, répartiteur, pompe à vide, bloc hydraulique ABS.
                    </div>
                </li>
                <li>
                    <b>Système d'alimentation :</b>
                    <div>
                        Allumeur, module électronique d'allumage, bobine, pompe à injection, pompes d'alimentation en
                        carburant,
                        boitier papillon d'injection, à l'exception des injecteurs.
                    </div>
                </li>
                <li>
                    <b>Dispositif d'embrayage :</b>
                    <div>
                        Mécanisme, fourchette, récepteur, émetteur.
                    </div>
                </li>
                <li>
                    <b>Important :</b>
                    <div>
                        Cette garantie est réservée aux véhicules de moins de 7 ans, avec une cylindrée, au maximum de
                        3.5
                        litres et
                        n'excédant pas la limite kilométrique à la souscription de 120 000 km pour les véhicules essence
                        et
                        150
                        000
                        km pour les véhicules diesel.
                    </div>
                </li>
            </template>

            <!--maxi plus-->
            <template v-if="type === INSURANCE_AUTO.TYPE_MAXI_PLUS.ID">
                <li>
                    <b>Moteur :</b>
                    <div>
                        L'arbre à cames, les coussinets de tête de bielle, les bielles, les culbuteurs et tiges de
                        culbuteurs,
                        poussoirs, chaînes de distribution, courroie de distribution (uniquement en cas de rupture),
                        paliers
                        de
                        vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile, culasse
                        et
                        joint
                        de culasse, turbo.
                    </div>
                </li>
                <li>
                    <b>Boîte de vitesse :</b>
                    <div>
                        <i>Manuelle : </i>Toutes les défaillances internes: Pignons, les arbres sélecteurs synchros, les
                        roulements.
                    </div>
                    <div>
                        <i>Automatique : </i>Pignons, pompe à huile, les bagues et les arbres, convertisseur de couple,
                        vannes
                        et
                        soupapes,
                        régulateur, plateau.
                    </div>
                </li>
                <li>
                    <b>Dispositif de transmission : </b>
                    <div>
                        Boîte de transfert, pont arrière, différentiels, pignons et couronnes, cardans, arbre de
                        transmission,
                        arbres de roues.
                    </div>
                </li>
                <li>
                    <b>
                        Composants complémentaires pour les véhicules hybrides :
                    </b>
                    <div>
                        Moteur électrique, convertisseur, chargeur, calculateur, onduleur, motoventilateur.
                    </div>
                </li>
                <li>
                    <b>Système refroidissement : </b>
                    <div>
                        Radiateur d'eau, pompe à eau, ventilateur, échangeur air, thermostat, refroidisseur d'huile
                        moteur
                        et
                        BV.
                    </div>
                </li>
                <li>
                    <b>Système de direction : </b>
                    <div>
                        Crémaillère ou boitier, pompe d'assistance, canalisation, réservoir. A l'exception de la
                        colonne,
                        des
                        rotules et des biellettes.
                    </div>
                </li>
                <li>
                    <b>Système électrique : </b>
                    <div>
                        Alternateur, démarreur, serrures de portes, moteur et mécanisme de lève-vitres, moteur
                        d'essuie-glace et
                        de
                        toit ouvrant, compresseur et condenseur de climatisation, à l'exception de la recharge de gaz.
                    </div>
                </li>
                <li>
                    <b>Système de freinage : </b>
                    <div>
                        Maître-cylindre, servofrein, répartiteur, limiteur, pompe à vide, bloc hydraulique ABS,
                        calculateur
                        ABS,
                        cylindres de roues, étriers de frein.
                    </div>
                </li>
                <li>
                    <b>Système d'alimentation : </b>
                    <div>
                        Allumeur, module électronique d'allumage, bobine, pompe à injection, boitier électronique
                        d'injection,
                        pompes d'alimentation en carburant, boitier papillon d'injection, injecteurs, vanne EGR,
                        débitmètre.
                    </div>
                </li>
                <li>
                    <b>Dispositif d'embrayage : </b>
                    <div>
                        Mécanisme, fourchette, récepteur, émetteur, volant-moteur.
                    </div>
                </li>
                <li>
                    <b>Dispositif de suspension : </b>
                    <div>
                        Ressorts, barres stabilisatrices, bras de suspension, rotules de suspension.
                    </div>
                </li>
                <li>
                    <b>Important : </b>
                    <div>
                        Cette garantie est réservée aux véhicules de moins de 5 ans, avec une cylindrée, au maximum de
                        3.5
                        litres et
                        n'excédant pas la limite kilométrique à la souscription de 150 000 km.
                    </div>
                </li>
            </template>

            <!--prestige-->
            <template v-if="type === INSURANCE_AUTO.TYPE_PRESTIGE.ID">
                <li>
                    <b>Moteur :</b>
                    <div>
                        L'arbre à cames, les coussinets de tête de bielle, les bielles, les culbuteurs et tiges de
                        culbuteurs,
                        poussoirs, chaïnes de distribution, courroie de distribution (uniquement en cas de rupture),
                        paliers
                        de
                        vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile, culasse
                        et
                        joint
                        de
                        culasse, turbo.
                    </div>
                </li>
                <li>
                    <b>Boîte de vitesse :</b>
                    <div>
                        <i>Manuelle: </i>Toutes les défaillances internes : Pignon, arbres, sélecteurs, synchros,
                        roulements.
                    </div>
                    <div>
                        <i>Automatique: </i>Pignons, pompe à huile, bagues et arbres, convertisseur de couple, vannes et
                        soupapes, régulateur, plateau, calculateur BVA.
                    </div>
                </li>
                <li>
                    <b>Dispositif de transmission :</b>
                    <div>
                        Boîte de transfert, pont arrière, différentiels, pignons et couronnes, cardans, arbre de
                        transmission,
                        arbres de roues.
                    </div>
                </li>
                <li>
                    <b>
                        Composants complémentaires pour les véhicules hybrides :
                    </b>
                    <div>
                        Moteur électrique, convertisseur, chargeur, calculateur, onduleur, motoventilateur.
                    </div>
                </li>
                <li>
                    <b>Système de refroidissement :</b>
                    <div>
                        Radiateur d'eau, pompe à eau, ventilateur, échangeur air, thermostat, refroidisseur d'huile
                        moteur
                        et
                        BV.
                    </div>
                </li>
                <li>
                    <b>Système de direction :</b>
                    <div>
                        Crémaillère ou boîtier, pompe d'assistance, canalisation, réservoir. A l'exception de la
                        colonne,
                        des
                        rotules et des biellettes.
                    </div>
                </li>
                <li>
                    <b>Système électrique :</b>
                    <div>
                        Alternateur, démarreur, serrures de portes, moteur et mécanisme de lève-vitres, moteur
                        d'essuie-glace et
                        de toit ouvrant, commodo/com 2000, compresseur et condenseur de climatisation, à l'exception de
                        la
                        recharge de gaz.
                    </div>
                </li>
                <li>
                    <b>Système de freinage :</b>
                    <div>
                        Maître-cylindre, servofrein, répartiteur, limiteur, pompe à vide, bloc hydraulique ABS,
                        calculateur
                        ABS,
                        cylindres de roues, étriers de frein.
                    </div>
                </li>
                <li>
                    <b>Système d'alimentation :</b>
                    <div>
                        Allumeur, module électronique d'allumage, bobine, pompe à injection, boîtier électronique
                        d'injection,
                        pompes d'alimentation en carburant, boîtier papillon d'injection, injecteurs, vanne EGR,
                        débitmètre.
                    </div>
                </li>
                <li>
                    <b>Système d'embrayage :</b>
                    <div>
                        Mécanisme, fourchette, récepteur, émetteur, volant-moteur.
                    </div>
                </li>
                <li>
                    <b>Dispositif d'embrayage :</b>
                    <div>
                        Ressorts, barres stabilisatrices, bras de suspension, rotules de suspension.
                    </div>
                </li>
                <li>
                    <b>Important :</b>
                    <div>
                        Cette garantie est réservée aux véhicules de moins de 5 ans, avec une cylindrée, au maximum de
                        3.5
                        litres et
                        n'excédant pas la limite kilométrique à la souscription de 150 000 km.
                    </div>
                </li>
            </template>
        </template>

    </ul>
</template>

<script>
    import {AUTO_ENGINE, INSURANCE_AUTO} from "../../constants/insuranceAuto";

    export default {
        name: 'GarantiesAccordesAuto',
        props: {
            insurance: Object,
        },
        computed: {
            type() {
                return +this.insurance.details.garantie;
            },
            engine() {
                return +this.insurance.details.car_fuel;
            },
            age() {
                return +this.insurance.vehicle_age;
            },
            kilometrage() {
                return +this.insurance.details.km_real;
            }
        },
        data() {
            return {
                INSURANCE_AUTO,
                AUTO_ENGINE,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Garantie/GarantiesAccordesAuto.vue